import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { reserveReducer } from './reserveSlice';
import { rsvConfigReducer } from './rsvConfigSlice';
import { reserveChangeReducer } from './reserveChangeSlice';
import { loginReducer } from './loginSlice';

const rootReducer = combineReducers({
  reserve: reserveReducer,
  rsvConfig: rsvConfigReducer,
  reserveChange: reserveChangeReducer,
  login: loginReducer,
});

export default configureStore({
  reducer: rootReducer,
});
